<div class="flex flex-col py-6 px-4">
  <div class="flex flex-col gap-4 mb-6 items-center">
    <ui-headline
      class="text-center"
      type="h16"
      mobile-type="h16"
      text-color="neutrals-900"
      font-weight="bold"
      content="Vista previa de la foto"
    />
    <img
      [src]="previewUrl"
      alt="Preview"
      class="w-full max-h-[380px] object-cover"
    />
  </div>
  <div class="flex flex-col mt-6 gap-2 items-stretch w-full">
    <ui-button
      type="primary"
      responsive="false"
      size="md"
      button-text="Confirmar entrega"
      [isLoading]="isLoading"
      (click)="onConfirmDelivery()"
    ></ui-button>
    <ui-button
      type="secondary"
      responsive="false"
      size="md"
      button-text="Tomar otra foto"
      (click)="onTakeOtherPhoto()"
    ></ui-button>
  </div>
</div>
